import { actions, events } from "../../js/state-machine/index";
import { prefix } from "../../js/utilities";
import { matchers } from "../../js/validate-props";
import { closeX } from "../../js/helpers/built-in-icons";

export const componentName = "Notification";

export const defaultProps = Object.freeze({
    closeIcon: true,
    title: null,
    messageBody: null,
    timeStamp: null,
    primaryActionText: null,
    secondaryActionText: null,
    primaryAction: () => {
        return true;
    },
    secondaryAction: () => {
        return true;
    },
});

export const schema = Object.freeze({
    closeIcon: matchers.boolean,
    title: matchers.or(matchers.null, matchers.string),
    messageBody: matchers.minChars(1),
    timeStamp: matchers.or(matchers.null, matchers.string),
    primaryActionText: matchers.or(matchers.null, matchers.string),
    secondaryActionText: matchers.or(matchers.null, matchers.string),
    primaryAction: matchers.or(matchers.null, matchers.function),
    secondaryAction: matchers.or(matchers.null, matchers.function),
});

// Actions mapped into event values
export const eventMap = Object.freeze({
    [actions.hide().type]: events.closing(componentName),
    [actions.show().type]: events.opening(componentName),

    // Show/hide will be replaced by summon/dismiss in this component
    // [actions.dismiss().type]: events.dismiss(componentName),
    // [actions.summon().type]: events.summon(componentName),
    // dismissed: events.dismissed(componentName),
    // summoned: events.summoned(componentName),
});

export const componentClasses = Object.freeze({
    wrapper: `${prefix}notification__wrapper`,
    base: `${prefix}notification`,
    body: `${prefix}notification__body`,
    header: `${prefix}notification__header`,
    headerTitle: `${prefix}notification__header-title`,
    message: `${prefix}notification__message`,
    footer: `${prefix}notification__footer`,
    button: {
        base: `${prefix}button`,
        primary: `${prefix}button--primary`,
        secondary: `${prefix}button--secondary`,
    },
    icon: {
        base: `${prefix}notification__icon`,
        close: `${prefix}notification__close-icon`,
    },
    show: `${prefix}show`,
});

export const views = Object.freeze({
    show: {
        classList: [componentClasses.show],
        attrs: { "aria-hidden": "false" },
    },
    hide: {
        classList: [`!${componentClasses.show}`],
        attrs: { "aria-hidden": "true" },
    },
});

export const icons = {
    close: closeX,
};
